import { ReducerType } from '../rootReducer'
import { BaseState } from '../modules/base'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import type { AppDispatch } from '../store'
import { RootState } from '../store'

export const BASE_STATE = (state: ReducerType): BaseState => state.base
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
export const useAppDispatch: () => AppDispatch = useDispatch
